import { usePicklistValues } from '@/core/dcr/hooks/usePicklistValues';
import { EntityType } from '@/core/graphql/generated/types';
import { useGetAllCountriesQuery } from '@/features/DcrForm/_graphql/query/GetAllCountries.hook';
import { useGetPreferredCountryQuery } from '@/features/DcrForm/_graphql/query/GetPreferredCountry.hook';

import { usePrefetchSuggestedFields } from './usePrefetchSuggestedFields';

export const usePrefetchDcrModalData = () => {
	const { data: preferredCountryData } = useGetPreferredCountryQuery();
	useGetAllCountriesQuery();

	const countryId =
		preferredCountryData?.preferredCountryDcrs.__typename === 'DCRResults'
			? preferredCountryData.preferredCountryDcrs.results[0]?.country?.id
			: undefined;

	const { picklists, loading: picklistsLoading } = usePicklistValues({
		enabled: !!countryId,
		countryId
	});

	usePrefetchSuggestedFields({
		entityType: EntityType.Hcp,
		countryId,
		picklists,
		picklistsLoading
	});
	usePrefetchSuggestedFields({
		entityType: EntityType.Hco,
		countryId,
		picklists,
		picklistsLoading
	});
};
